import { render, staticRenderFns } from "./sendsms.vue?vue&type=template&id=4a79b2c4&scoped=true&"
import script from "./sendsms.vue?vue&type=script&lang=js&"
export * from "./sendsms.vue?vue&type=script&lang=js&"
import style0 from "./sendsms.vue?vue&type=style&index=0&id=4a79b2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a79b2c4",
  null
  
)

export default component.exports